import { useUpdateProgressionTemplateMutation } from "../../libs/progression/api";
import { ProgressionTemplate } from "../../libs/progression/types";
import { Modal } from "../Modal";
import { ProgressionForm } from "./ProgressionForm";

type Props = {
  openModal: string | undefined;
  setOpenModal: (modal: string | undefined) => void;
  templateToUpdate: ProgressionTemplate | undefined;
};

export const EditProgressionModal: React.FC<Props> = ({
  openModal,
  setOpenModal,
  templateToUpdate,
}) => {
  const [updateTemplate, { isLoading, error }] = useUpdateProgressionTemplateMutation();

  const onSubmit = (template: Omit<ProgressionTemplate, "id">) => {
    if (!templateToUpdate) return;
    updateTemplate({ ...template, id: templateToUpdate.id })
      .unwrap()
      .then(() => setOpenModal(undefined))
      .catch(() => {});
  };

  if (!templateToUpdate) return null;

  return (
    <Modal
      title={`Modifica: ${templateToUpdate.name}`}
      openModal={openModal === "edit" ? "edit" : undefined}
      setOpenModal={setOpenModal}
      fullScreen
    >
      {openModal === "edit" && (
        <ProgressionForm
          key={templateToUpdate.id}
          defaultValues={templateToUpdate}
          onSubmit={onSubmit}
          isPending={isLoading}
        />
      )}
      {error && (
        <p className="mt-2 text-sm text-red-600">
          Errore durante la modifica della progressione.
        </p>
      )}
    </Modal>
  );
};
